import { useEffect, useState } from "react";
import { Bar, BarChart, CartesianGrid, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import { Loader2, X } from "lucide-react";
import { api, errMsg } from "@/lib/api";
import { activLabel, exact, invLabel, relTime, roleLabel, shortDate } from "./usersFormat";

const Row = ({ k, v, testid }) => (
  <div className="flex justify-between gap-3 py-1.5 border-b border-[var(--c-line)] last:border-0 text-sm">
    <span className="c-muted">{k}</span><span data-testid={testid} className="font-medium text-right">{v}</span>
  </div>
);

export const UserDetail = ({ id, onClose }) => {
  const [u, setU] = useState(null);
  const [err, setErr] = useState(null);
  useEffect(() => { api.get(`/admin/uso/usuarios/${id}`).then((r) => setU(r.data)).catch((e) => setErr(errMsg(e))); }, [id]);
  return (
    <div data-testid="admin-user-detail" className="fixed inset-0 z-50 bg-black/40 flex items-end md:items-center justify-center" onClick={onClose}>
      <div className="bg-[var(--c-bg)] w-full max-w-lg max-h-[90vh] overflow-y-auto rounded-t-2xl md:rounded-2xl p-4 space-y-3" onClick={(e) => e.stopPropagation()}>
        <div className="flex items-start justify-between">
          <div>
            <h2 data-testid="user-detail-name" className="font-heading text-xl font-extrabold">{u?.nombre_publico || "…"}</h2>
            {u && <p className="text-xs c-muted">@{u.usuario} · {roleLabel(u)}</p>}
          </div>
          <button data-testid="user-detail-close" onClick={onClose} className="p-1.5 rounded-lg"><X className="w-5 h-5" /></button>
        </div>
        {err ? <p className="text-sm text-red-600">{err}</p> : !u ? <div className="py-10 flex justify-center"><Loader2 className="w-6 h-6 animate-spin c-muted" /></div> : (
          <>
            <div data-testid="user-detail-chart" className="c-card p-3 h-56">
              <p className="font-mono text-[10px] tracking-[0.2em] uppercase c-muted mb-2">Minutos por día · 30 días</p>
              <ResponsiveContainer width="100%" height="88%">
                <BarChart data={u.serie.map((d) => ({ ...d, label: d.dia.slice(5) }))} margin={{ left: -24, right: 4 }}>
                  <CartesianGrid strokeDasharray="3 3" opacity={0.25} />
                  <XAxis dataKey="label" tick={{ fontSize: 9 }} interval={4} />
                  <YAxis allowDecimals={false} tick={{ fontSize: 10 }} />
                  <Tooltip />
                  <Bar dataKey="minutos" name="Minutos" fill="#0b2a47" radius={[3, 3, 0, 0]} />
                </BarChart>
              </ResponsiveContainer>
            </div>
            <div className="c-card px-3.5 py-1">
              <Row k="Invitado por" v={u.invitado_por || "—"} testid="user-detail-invitado" />
              <Row k="Registro" v={shortDate(u.registro)} testid="user-detail-registro" />
              <Row k="Última entrada" v={`${relTime(u.ultima_entrada)} · ${exact(u.ultima_entrada)}`} testid="user-detail-ultima" />
              <Row k="Minutos hoy" v={u.minutos_hoy} testid="user-detail-min-hoy" />
              <Row k="Minutos 7 días" v={u.minutos_7d} testid="user-detail-min-7d" />
              <Row k="Promedio diario (semana)" v={u.promedio_diario_7d} testid="user-detail-promedio" />
              <Row k="Invitaciones (enviadas / registradas / activadas)" v={invLabel(u.invitaciones)} testid="user-detail-invitaciones" />
              <Row k="Contactos" v={`${u.contactos} · ${u.compartibles} compartibles`} testid="user-detail-contactos" />
              <Row k="Activado" v={activLabel(u)} testid="user-detail-activado" />
              <Row k="Fundador" v={u.numero_fundador ? `#${u.numero_fundador}` : "—"} testid="user-detail-fundador" />
            </div>
          </>
        )}
      </div>
    </div>
  );
};
